<template>
  <div class="float">
    <div class="my-float">
      <plus-icon width=32 height=32 color=white ></plus-icon>
    </div>
  </div>
</template>

<script>
import { PlusIcon } from 'vue-feather-icons';

export default {
  computed: {
  },
  methods: {
  },
  components: {
    PlusIcon,
  },
};
</script>

<style>
.float{
	position:fixed;
	width:48px;
	height:48px;
	bottom:78px;
	right:22px;
	background-color:#000000;
	color:#FFF;
	border-radius:72px;
	text-align:center;
  cursor: pointer;
	box-shadow: 2px 2px 3px #999;
  z-index: 1001;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}
.float:hover{
  opacity: 1;
}
.my-float{
	margin-top:6px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// FloatButton.vue?15e585d8